import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const Login = () => {
  const { signInUsingGoogle } = useAuth();
  return (
    <div>
      <h2>Please Login</h2>
      <form onSubmit="">
        <input type="email" name="" id="" placeholder="your email" />
        <br />
        <input type="password" name="" id="" placeholder="Password" />
        <br />
        <input type="submit" value="Submit" />
      </form>
      <p>
        new to ema-john? <Link to="/register">Create Account </Link>
      </p>
      <div>----------or----------</div>

      <button onClick={signInUsingGoogle} className="btn btn-danger">
        Google Sign in
      </button>
    </div>
  );
};

export default Login;
